import {
  isConsentCategoryGranted,
  readClientConsent,
} from '@frodo/lib/utils/consent';

export const hasAnalyticsConsent = () => {
  if (typeof window !== 'undefined' && window.consentManager?.ready) {
    return isConsentCategoryGranted(window.consentManager.get(), 'analytical');
  }

  return readClientConsent()?.analytical ?? false;
};

export const showPrivacyBanner = () => {
  window.consentManager?.showBanner();
};
